import React, { Component } from "react"
import Accordion from "../../styleguide/js/components/accordion"

class AirportAccordion extends Component {
  constructor(props) {
    super(props)
    this.nodeRef = React.createRef()
    this.accordion = undefined
  }

  killAccordion(accordion) {
    if (accordion && accordion.resizeTimeout) {
      clearTimeout(accordion.resizeTimeout)
    }
    if (accordion && accordion.updateHeightTimeout) {
      clearTimeout(accordion.updateHeightTimeout)
    }
    delete this.accordion
  }

  componentDidMount() {
    if (this.accordion) {
      this.killAccordion(this.accordion)
    }
    this.accordion = new Accordion({
      el: this.nodeRef.current,
      eventName: Accordion.EVENT.CLICK,
      disposable: false,
      persistentElement: null,
    })
  }

  componentDidUpdate() {
    if (this.accordion) {
      this.killAccordion(this.accordion)
    }
    this.accordion = new Accordion({
      el: this.nodeRef.current,
      eventName: Accordion.EVENT.CLICK,
      disposable: false,
      persistentElement: null,
    })
  }

  componentWillUnmount() {
    if (this.accordion) {
      this.killAccordion(this.accordion)
    }
  }

  render() {
    const { label, className, isActive } = this.props

    return (
      <div className={`accordion js--accordion ${isActive ? "is-active" : ""}`} ref={this.nodeRef}>
        <div className="accordion__trigger js--accordion-trigger">
          <div className="accordion__title">
            <h3 className={className}>
              <a id={"first_letter_" + label.substr(0, 1)}></a>
              {label}
            </h3>

            <span className="icon">
              <svg className="svg-icon svg-icon--arrowdownangle">
                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-arrowdownangle">
                  &nbsp;
                </use>
              </svg>
            </span>
          </div>
        </div>
        <div className="accordion__content js--accordion-content countryDetails" style={{ maxHeight: "0px" }}>
          {this.props.children}
        </div>
      </div>
    )
  }
}
export default AirportAccordion
